module.exports = __webpack_public_path__ + "img/rergister-one.02ebfebe.png";